console.log('access');

// use a script tag or an external JS file
document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)
    // gsap code here!

    const bicycle = document.querySelectorAll('.bicycle_img');
    const taxi = document.querySelectorAll('.taxi_img');
    const imgTaxi = document.querySelectorAll('.img-text');

    taxi.forEach((taxi) => {

        bicycle.forEach((bicycle) => {
            gsap.set(bicycle, {
                y: -50,
            })
            gsap.to(bicycle, {
                y: 0,
                scrollTrigger: {
                    trigger: bicycle,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 1,
                }
            })

            gsap.set(taxi, {
                y: -50,
            })
            gsap.to(taxi, {
                y: 0,
                scrollTrigger: {
                    trigger: taxi,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 1,
                }
            })



            if (imgTaxi) {
                gsap.fromTo(imgTaxi[0], {
                    y: 50
                }, {
                    y: -50,
                    scrollTrigger: {
                        trigger: bicycle,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 1.5
                    }
                });
                gsap.fromTo(imgTaxi[1], {
                    y: 50
                }, {
                    y: -50,
                    scrollTrigger: {
                        trigger: taxi,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: 1.5
                    }
                });
            }
        })
    });



});